import { ASSETS } from "../config/assets";

const Sidebar = () => {
  const template = (window as any)?.post_template || {};
  const sidebar = template.wellanail_flex_sidebar || {};

  const t1Image = sidebar.testimonial_1_image || ASSETS.testimonials.mariaZ;
  const t2Image = sidebar.testimonial_2_image || ASSETS.testimonials.josephT;
  const t3Image = sidebar.testimonial_3_image || ASSETS.testimonials.deannaS;

  return (
    <div className="col-20">
      <div className="right">
        <div className="special_offer">
          <h2>
            {sidebar.tr_sidebar_heading ||
              "WELLANAIL ANTI-FUNGAL OIL TESTIMONIALS"}
          </h2>
          <img src={t1Image} alt="Testimonial 1" className="center" />
          <p>
            {sidebar.tr_testimonial_1_text ||
              "“I was hesitant at first because I’ve tried so many treatments that didn’t work, but the WellaNail Anti-Fungal oil exceeded my expectations! Within two weeks, my nails looked healthier, and the itchiness was gone. It’s so easy to use, and I love that it’s all-natural!”"}
            <br />
            {sidebar.tr_testimonial_1_author || "Maria Z."}
          </p>
          <img src={t2Image} alt="Testimonial 2" className="center" />
          <p>
            {sidebar.tr_testimonial_2_text ||
              "“I’ve been using the WellaNail Anti-Fungal oil daily for about a week, and I can already see the difference. My nails feel stronger, and the discoloration is fading. I can’t believe how effective this is compared to other products I’ve tried!”"}
            <br /> {sidebar.tr_testimonial_2_author || "Joseph T."}
          </p>
          <img src={t3Image} alt="Testimonial 3" className="center" />
          <p>
            {sidebar.tr_testimonial_3_text ||
              "“My husband and I both use the WellaNail Anti-Fungal oil, and it’s been amazing. It’s super convenient, and we’ve noticed visible results in such a short time. No irritation, just healthier nails. Highly recommend!”"}
            <br /> {sidebar.tr_testimonial_3_author || "Deanna S."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
